module.exports = __webpack_public_path__ + "static/media/Apps.43109769.svg";